import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import SEO from './components/SEO';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Courses from './components/Courses';
import CourseDetail from './components/CourseDetail';
import About from './components/About';
import Features from './components/Features';
import Stats from './components/Stats';
import Blog from './components/Blog';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';
import TawkTo from './components/TawkTo';
import TermsAndConditions from './components/TermsAndConditions';
import Sitemap from './components/Sitemap';
import EnquiryInstructor from './components/EnquiryInstructor';
import EnquiryPartnership from './components/EnquiryPartnership';
import EnquiryCareer from './components/EnquiryCareer';
import './App.css';

// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function HomePage() {
  return (
    <>
      <SEO
        title="IT Certification Training – Data Science, Cloud, Cyber Security & More"
        description="TrainingProtec offers live instructor-led courses in Data Science, Cloud Computing, Cyber Security, Full Stack Development, Digital Marketing & more. Expert trainers, real projects, job assistance."
        keywords="IT training, data science course, cloud computing, cyber security, full stack development, digital marketing, business analytics, UI UX design, mobile app development, online training India"
        canonical="/"
      />
      <Hero />
      <Courses />
      <About />
      <Features />
      <Stats />
      <Testimonials />
      <Blog />
      <Contact />
    </>
  );
}

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);

  // Handle hash scroll after loading completes
  useEffect(() => {
    if (!loading) {
      const hash = window.location.hash;
      if (hash) {
        setTimeout(() => {
          const element = document.getElementById(hash.replace('#', ''));
          if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
          }
        }, 300);
      }
    }
  }, [loading]);

  if (loading) {
    return (
      <div className="loader-container">
        <div className="cyber-loader">
          <div className="loader-ring"></div>
          <div className="loader-ring"></div>
          <div className="loader-ring"></div>
          <span className="loader-text">TrainingProtec</span>
        </div>
      </div>
    );
  }

  return (
    <HelmetProvider>
    <Router>
      <div className="App">
        <Navbar />
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/courses/:slug" element={<CourseDetail />} />
          <Route path="/terms" element={<TermsAndConditions section="terms" />} />
          <Route path="/privacy" element={<TermsAndConditions section="privacy" />} />
          <Route path="/refund" element={<TermsAndConditions section="refund" />} />
          <Route path="/enquiry/instructor" element={<EnquiryInstructor />} />
          <Route path="/enquiry/partnership" element={<EnquiryPartnership />} />
          <Route path="/enquiry/career" element={<EnquiryCareer />} />
          <Route path="/sitemap" element={<Sitemap />} />
        </Routes>
        <Footer />
        <TawkTo />
      </div>
    </Router>
    </HelmetProvider>
  );
}

export default App;
